import React, { memo, useMemo } from "react";
import { Box } from "@mui/material";
import { CompanyEventProto } from "../../proto/generated/company_event";
import useStyles from "./styles";
import { CorporateAction, typeFromJSON } from '../../proto/generated/corporate-action'
import { CompanyEventDisplay, CorporateActionDisplay, getColorForAction } from '../chartV2/corporateActions'

interface EventDetailsListProps {
    eventDetails: CompanyEventProto[];
    corporateActions?: CorporateAction[];
}

const EventDetailsList: React.FC<EventDetailsListProps> = ({ eventDetails, corporateActions }) => {
    const { classes } = useStyles();

    const allEvents = useMemo(() => {
        const events = eventDetails.map((event) => ({
            type: "companyEvent" as const,
            data: event
        }));

        const actions = (corporateActions || []).map((action) => ({
            type: "corporateAction" as const,
            data: action
        }));

        return [...events, ...actions];
    }, [eventDetails, corporateActions]);

    if (!allEvents.length) return null;
    return (
        <>
            {allEvents.map((item, index) => {
                const isCompanyEvent = item.type === "companyEvent";

                return (
                    <React.Fragment key={index}>
                        <Box className={classes.value} sx={{ width: '100%' }} maxWidth={325}>
                            {isCompanyEvent ? (
                                <CompanyEventDisplay
                                    event={item.data}
                                    avatarProps={{
                                        sx: {
                                            bgcolor: 'transparent',
                                            width: 24,
                                            height: 24,
                                            fontSize: 12,
                                            borderColor: 'skyblue',
                                            borderWidth: 2,
                                            color: 'skyblue'
                                        },
                                    }}
                                />
                            ) : (
                                <CorporateActionDisplay
                                    action={item.data}
                                    avatarProps={{
                                        sx: {
                                            bgcolor: 'transparent',
                                            width: 24,
                                            height: 24,
                                            fontSize: 12,
                                            borderColor: getColorForAction(typeFromJSON(item.data.type)),
                                            borderWidth: 2,
                                            color: getColorForAction(typeFromJSON(item.data.type))
                                        },
                                    }}
                                />
                            )}
                        </Box>
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default memo(EventDetailsList);